module.exports = __webpack_public_path__ + "img/mobile-add.a8236875.svg";